import { gql } from '@apollo/client';

export default gql`
  query GetAdvisorSystems($advisor_id: Int!) {
    getAdvisorSystems(advisor_id: $advisor_id) {
      provider_id
      provider_name
      recipient_email
      access_status
      applied_at
      cancelled_at
      changed_at
      scheduled_at
      letter_template_name
    }
  }
`;
